module.exports = __webpack_public_path__ + "static/media/000_insti_mobile.9d41a7e2.jpg";